//--------------------------------------------------
// imported classes
//--------------------------------------------------
const BaseMediator = require('@/tbs/controller/BaseMediator')
const ClassFunc = require('@/tbs/util/ClassFunc')
const MatchConvertor = require('@/tbs/model/vo/Match')
const MatchManagerConvertor = require('@/tbs/model/vo/MatchManager')
const MatchSignupConfig = require('@/tbs/model/vo/MatchSignupConfig')
const DataConvertor = require('@/tbs/core/DataConvertor')
const ModelLocator = require('@/tbs/model/ModelLocator')

/**
 * The MatchMediator class maintains the business logic
 * for the organization.
 */
const tbs_controller_MatchSignupPaymentMediator = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, BaseMediator, arguments)
    // console.log('tbs_controller_MatchSignupPaymentMediator constructor')
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_controller_MatchSignupPaymentMediator.prototype = {
    //--------------------------------------------------
    // api method
    //--------------------------------------------------
    handleCreationComplete: function() {
        if (this._bridge.isCreate()) {
            this.loadMatchInfo(this._bridge.getRouteParam('id'))
        }
        else if (this._bridge.isManage()) {
            this.target().match = {id: this._bridge.getRouteParam('id')}
            this.creationComplete()
        }
        else {
            this.creationComplete()
        }
    },
    handleQueryService: function(e) {
        console.log('handleQueryService')
        const self = this
        // load the signup config data while isEdit and isCreate
        if (this._bridge.isEdit()) {
            const convertor = self.p_convertor()
            const type = 'get'
            this.matchSignup = DataConvertor.transform(convertor, e.data.payload, type)
            this.loadMatchGroupByMatch(this.matchSignup.matchId)
        }
    },
    handleUpdateService: function(e) {
        // console.log('@handleUpdateService', e)
        if (e.data.result == true) {
            console.log('clear the status', this._bridge.getRouteName())
            ModelLocator.setStatus(this._bridge.getRouteName(), null)
            this._bridge.back()
        }
    },
    loadMatchGroupByMatch(matchId) {
        console.log('loadMatchGroupByMatch', matchId)
        const self = this
        self.loadViewObjectData(new MatchManagerConvertor, {id: matchId}, function(data) {
            console.log('loadMatchGroupByMatch', data)
            self.loadSignupConfig(data.match.matchGroupId)
        }, 'manage')
    },
    loadSignupConfig: function(matchGroupId) {
        console.log('loadSignupConfig', matchGroupId)
        const self = this
        self.loadViewObjectData(new MatchSignupConfig, {matchGroupId: matchGroupId}, function(data) {
            console.log('loadSignupConfig', data)
            self.matchSignup.config = {
                teamSignupItems: self.convertItems2Summary(data.teamSignupItems),
                memberSignupItems: self.convertItems2Summary(data.memberSignupItems),
                teamNumLabel: data.teamNumLabel,
                staffNumLabel: data.staffNumLabel,
                matchGroupId: matchGroupId,
            }
            console.log('@matchSignup', self.matchSignup)
            self.target().matchSignup = self.matchSignup
        })
    },
    loadMatchInfo: function(matchId) {
        console.log('loadMatchInfo', matchId)
        const self = this
        self.loadViewObjectData(new MatchConvertor, {id: matchId}, function(data) {
            console.log('loadMatchInfo', data)
            self.matchSignup = {teamTotal: data.teamTotal, matchId: self._bridge.getRouteParam('id')}
            self.loadMatchGroupByMatch(matchId)
        })
    },
    convertItems2Summary: function(items) {
        if (items.length <= 6) {
            return items
        }
        const summaryItems = []
        for (let i = 0; i < 5; i++) {
            let item = items[i]
            summaryItems.push(item)
        }
        summaryItems.push({
            label: '...',
            value: '0',
        })
        return summaryItems
    },
}

//--------------------------------------------------
// extends the BaseMediator
//--------------------------------------------------
ClassFunc.extend(tbs_controller_MatchSignupPaymentMediator, BaseMediator);

module.exports = tbs_controller_MatchSignupPaymentMediator